import { type FC, useMemo } from "react";
import FontAwesomeLight from "../../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { type FileConnectionType } from "../MediaUtilities";
import { FileConnection } from "./FileConnection";

interface Props {
    connections: Array<FileConnectionType>;
}

const NAME_MAP: Record<string, string> = {
    "App\\Models\\CustomerDisplay": "Customer Displays",
    "App\\Models\\Receipt"        : "Receipts",
    "App\\Models\\Statement"      : "Statements",
    "App\\Models\\Product"        : "Products",
    "App\\Models\\User"           : "Users",
    "App\\Models\\Order"          : "Orders",
    "App\\Models\\SaleKey"        : "Sales Keys",
    "App\\Models\\Outlet"         : "Outlets",
    "OrderReview"                 : "Order Reviews",
};

export const FileConnectionList: FC<Props> = ({ connections }) => {
    const [ grouped, keys ] = useMemo(() => {
        const results: Record<string, Array<FileConnectionType>> = {};
        const keys: Array<string> = [];

        // Group the connections
        for(const connection of connections) {
            if(typeof results[connection.type] === "undefined") {
                results[connection.type] = [];
                keys.push(connection.type);
            }

            results[connection.type].push(connection);
        }

        // Sort the group keys
        keys.sort((a, b) => {
            return NAME_MAP[a].localeCompare(NAME_MAP[b]);
        });

        return [ results, keys ];
    }, [ connections ]);

    return (
        <div className="mt-4 pl-2 pr-6">
            <div className="font-bold text-lg"><FontAwesomeLight icon="paperclip" /> Used by</div>
            <ul className="text-left my-0 space-y-2">
                {keys.map(key => (
                    <li key={key}>
                        {NAME_MAP[key]}
                        <ul className="pl-4">
                            {grouped[key].map(connection => (
                                <li
                                    key={connection.id}
                                    className="w-full"
                                >
                                    <div className="whitespace-nowrap w-full overflow-hidden text-ellipsis">
                                        <FileConnection
                                            connection={connection}
                                        />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
};
